export default __webpack_public_path__ + "static/media/branchName.def49be6.build-env";